import decodeResultsMutations from "@/store/mutations/decodeResults";
import sharedMutations from "@/store/mutations/shared";
import matrixMutations from "@/store/mutations/matrix";

export default {
  ...decodeResultsMutations,
  ...sharedMutations,
  ...matrixMutations,
};
